import { SimpleGrid, Stack } from '@mantine/core'
import { useQueryClient } from '@tanstack/react-query'
import {
  sendDownlinkMessage,
  sendDownlinkMessageSchema,
} from 'api/loraDevices/sendDownlinkMessage'
import { useFormMutation } from 'hooks/useFormMutation'
import { FormProvider } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { DownlinkForm } from './DownlinkForm'
import { DownlinkHistory } from './DownlinkHistory'
import { DownlinkPresetsCard } from './DownlinkPresetsCard'

export const LoraDeviceMessaging = ({
  deviceModelId,
}: {
  deviceModelId: string | null
}) => {
  const queryClient = useQueryClient()
  const deviceId = useParams().deviceId as string
  const { methods, onSubmit, isLoading } = useFormMutation({
    mutationFn: sendDownlinkMessage(deviceId),
    schema: sendDownlinkMessageSchema,
    onSuccess: () => {
      queryClient.refetchQueries(['downlink-messages', deviceId])
    },
  })

  return (
    <FormProvider {...methods}>
      <form onSubmit={onSubmit}>
        <Stack>
          <SimpleGrid cols={{ base: 1, lg: 2 }}>
            <DownlinkForm isLoading={isLoading} />
            {deviceModelId && (
              <DownlinkPresetsCard deviceModelId={deviceModelId} />
            )}
          </SimpleGrid>
          <DownlinkHistory deviceModelId={deviceModelId || ''} />
        </Stack>
      </form>
    </FormProvider>
  )
}
